import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import PropTypes from "prop-types";
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { BOOKING_FORM_STATUS } from '../../../config/constant';
import disabledEdit from "../../../assets/icons/disabled-edit.svg";
import edit from "../../../assets/icons/ic-solar_pen-bold.svg";
import { setEditPreviewApplicant, setIsFromPreview, setShowSaveAndPreview } from '../../new-booking-form/new-booking-form.slice';

const CompanyDetails = ({ applicantData }) => {
  const { t } = useTranslation("common");
  const { t: tButton } = useTranslation("common", { keyPrefix: "button" });
  const { entity } = useSelector((state) => state?.newBookingForm);
  const history = useHistory();
  const dispatch = useDispatch();
  const { oppId } = useParams();

  return (
    <div className="applicantDetailsCard">
      <div className="editTitleRow">
        <div className="btnApplicantTop">
          {t("companyDetails.title", { entity })}
        </div>
        {(applicantData?.isCompleted === true) ? (
          <Tooltip
            enterTouchDelay={0}
            title={
              applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED_OFFLINE
                ? t("preview.tooltip.signedOffline")
                : applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.PARTIALLY_SIGNED
                  ? undefined
                  : applicantData?.leegalityData?.isSignLater === true
                    ? t("preview.tooltip.signInLater")
                    : t("preview.tooltip.signNow")
            }
            arrow
          >
            <div className="editButtonDisabled">
              <img src={disabledEdit} alt="Edit" /> {tButton("edit")}
            </div>
          </Tooltip>) : (
          <div
            className="editButton"
            onClick={() => {
              dispatch(
                setIsFromPreview({ value: true })
              );
              dispatch(setShowSaveAndPreview(true))
              dispatch(setEditPreviewApplicant(true));
              history.push(`/booking-form/${oppId}`);
            }}
          >
            <img src={edit} alt="Edit" /> {tButton("edit")}
          </div>
        )}
      </div>
      <Typography sx={{ color: '#1A407D', fontSize: '24px', fontWeight: 600, mb: 2 }}>
        {applicantData?.companyDetails?.companyName || "N/A"}
      </Typography>
      <Grid container spacing={2} >
        <Grid item xs={12} md={6}>
          <div className="personalInfoRow">
            <p className="label200">{t("companyDetails.labels.companyGstNumber", { entity })}:</p>
            <span className="wordBreakMobile">
              {applicantData?.companyDetails?.gstNumber || "N/A"}
            </span>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div className="personalInfoRow">
            <p className="label200">{t("companyDetails.labels.companyPanNumber", { entity })}:</p>
            <span className="wordBreakMobile">
              {applicantData?.companyDetails?.companyPan || "N/A"}
            </span>
          </div>
        </Grid>
      </Grid>

      <Typography sx={{ fontSize: '14px', fontWeight: 600, fontStyle: 'italic', my: 2 }}>
        {t("preview.kycNote")}
      </Typography>
      <Divider sx={{ border: '1px dashed #D6D6D6', mb: 2 }} />
      <div className="personalInfoRow">
        <p className="label200">{t("companyDetails.labels.companyAddress", { entity })}:</p>
        <span className="wordBreakMobile">
          {applicantData?.companyDetails?.companyAddress || "N/A"}
        </span>
      </div>
    </div>
  )
}



CompanyDetails.propTypes = {
  applicantData: PropTypes.object,
};

export default CompanyDetails